(() => {
  const CURRENCY_NOTICE = 'Payments processed in ZAR (South African rand)';
  const STICKY_CURRENCY_NOTICE = 'Payments processed in ZAR';
  const MOBILE_STICKY_Z_INDEX = '2147483647';
  const MOBILE_WIDGET_Z_INDEX = '2147482000';
  const MOBILE_CHAT_CLEARANCE = 'calc(108px + env(safe-area-inset-bottom))';
  const MOBILE_WIDGET_GAP = 16;

  const ensureCurrencyNoticeStyles = () => {
    if (document.getElementById('pm-zar-notice-styles')) return;

    const style = document.createElement('style');
    style.id = 'pm-zar-notice-styles';
    style.textContent = `
      .pm-zar-price-stack {
        display: grid;
        gap: .22rem;
        min-width: 0;
      }
      .pm-zar-price-stack > strong {
        display: block;
      }
      .pm-zar-price-note {
        display: block;
        margin: 0;
        color: #68788d;
        font-size: 1.05rem;
        font-weight: 700;
        line-height: 1.35;
        letter-spacing: .01em;
        white-space: normal;
      }
      .pm-zar-price-note--standard {
        margin-top: .45rem;
        color: rgba(var(--color-foreground), .65);
        font-size: 1.1rem;
      }
      .pm-zar-sticky-note {
        display: block !important;
        margin: .12rem 0 0;
        color: #c5d0de !important;
        font-size: .82rem !important;
        font-weight: 700;
        font-style: normal;
        line-height: 1.15;
        letter-spacing: .01em !important;
        white-space: nowrap !important;
        overflow: visible !important;
        text-overflow: clip !important;
      }
      @media (max-width: 749px) {
        .pm-zar-price-note {
          font-size: 1rem;
        }
        .pm-cro__mobile-buy,
        .pm-bmx__mobile-buy {
          position: fixed !important;
          z-index: 2147483647 !important;
          left: 0 !important;
          right: 0 !important;
          bottom: 0 !important;
          width: 100vw !important;
          max-width: none !important;
          box-sizing: border-box !important;
          isolation: isolate !important;
          opacity: 1 !important;
          visibility: visible !important;
          pointer-events: auto !important;
          overflow: visible !important;
          background: #040b15 !important;
        }
        .vapi-widget-button,
        .vapi-widget-container,
        .vapi-widget-frame {
          right: 12px !important;
          left: auto !important;
          bottom: calc(108px + env(safe-area-inset-bottom)) !important;
          z-index: 2147482000 !important;
        }
      }
      @media (max-width: 390px) {
        .pm-zar-sticky-note {
          font-size: .76rem !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const addCurrencyNoticeToPriceRow = (selector) => {
    document.querySelectorAll(selector).forEach((row) => {
      if (row.querySelector('.pm-zar-price-note')) return;

      const price = Array.from(row.children).find((child) => child.tagName === 'STRONG') || row.querySelector('strong');
      if (!price) return;

      let stack = price.parentElement;
      if (!stack || !stack.classList.contains('pm-zar-price-stack')) {
        stack = document.createElement('div');
        stack.className = 'pm-zar-price-stack';
        price.before(stack);
        stack.appendChild(price);
      }

      const note = document.createElement('small');
      note.className = 'pm-zar-price-note';
      note.textContent = CURRENCY_NOTICE;
      stack.appendChild(note);
    });
  };

  const addCurrencyNoticeToStandardPrice = () => {
    document.querySelectorAll('product-info [id^="price-"]').forEach((container) => {
      if (container.querySelector('.pm-zar-price-note')) return;

      const price = container.querySelector('.price');
      if (!price) return;

      const note = document.createElement('small');
      note.className = 'pm-zar-price-note pm-zar-price-note--standard';
      note.textContent = CURRENCY_NOTICE;
      price.insertAdjacentElement('afterend', note);
    });
  };

  const addCurrencyNoticeToMobileSticky = () => {
    document.querySelectorAll('.pm-cro__mobile-buy, .pm-bmx__mobile-buy').forEach((bar) => {
      if (bar.querySelector('.pm-zar-sticky-note')) return;

      const price = bar.querySelector('span > strong');
      if (!price) return;

      const note = document.createElement('em');
      note.className = 'pm-zar-sticky-note';
      note.textContent = STICKY_CURRENCY_NOTICE;
      price.insertAdjacentElement('afterend', note);
    });
  };

  const initCurrencyNotice = () => {
    ensureCurrencyNoticeStyles();
    addCurrencyNoticeToPriceRow('.pm-cro__price-row');
    addCurrencyNoticeToPriceRow('.pm-bmx__price-row');
    addCurrencyNoticeToStandardPrice();
    addCurrencyNoticeToMobileSticky();
  };

  const rectsOverlap = (a, b) => (
    a.left < b.right &&
    a.right > b.left &&
    a.top < b.bottom &&
    a.bottom > b.top
  );

  const findFixedAncestor = (node) => {
    let current = node;
    for (let i = 0; current && i < 12; i += 1) {
      if (current.nodeType === 1) {
        const computed = window.getComputedStyle(current);
        if (computed.position === 'fixed' || computed.position === 'sticky') return current;
      }

      if (current.parentElement) {
        current = current.parentElement;
      } else {
        const root = current.getRootNode?.();
        current = root?.host || null;
      }
    }
    return null;
  };

  const moveFloatingWidgetClear = (node, clearance) => {
    if (!node || node.matches?.('.pm-cro__mobile-buy, .pm-bmx__mobile-buy')) return;

    node.style.setProperty('z-index', MOBILE_WIDGET_Z_INDEX, 'important');

    const rect = node.getBoundingClientRect();
    const looksLikeFloatingWidget = (
      rect.width > 0 &&
      rect.height > 0 &&
      rect.width < window.innerWidth * 0.9 &&
      rect.height < window.innerHeight * 0.5
    );

    if (looksLikeFloatingWidget) {
      node.style.setProperty('bottom', `calc(${clearance}px + env(safe-area-inset-bottom))`, 'important');
    }
  };

  const protectMobileSticky = () => {
    if (!window.matchMedia('(max-width: 749px)').matches || !document.body) return;

    const bars = Array.from(document.querySelectorAll('.pm-cro__mobile-buy, .pm-bmx__mobile-buy'));
    if (!bars.length) return;

    bars.forEach((bar) => {
      if (bar.parentElement !== document.body) {
        document.body.appendChild(bar);
      }

      bar.style.setProperty('position', 'fixed', 'important');
      bar.style.setProperty('z-index', MOBILE_STICKY_Z_INDEX, 'important');
      bar.style.setProperty('left', '0', 'important');
      bar.style.setProperty('right', '0', 'important');
      bar.style.setProperty('bottom', '0', 'important');
      bar.style.setProperty('width', '100vw', 'important');
      bar.style.setProperty('max-width', 'none', 'important');
      bar.style.setProperty('box-sizing', 'border-box', 'important');
      bar.style.setProperty('isolation', 'isolate', 'important');
      bar.style.setProperty('opacity', '1', 'important');
      bar.style.setProperty('visibility', 'visible', 'important');
      bar.style.setProperty('pointer-events', 'auto', 'important');
      bar.style.setProperty('overflow', 'visible', 'important');
      bar.style.setProperty('background', '#040b15', 'important');

      requestAnimationFrame(() => {
        const stickyRect = bar.getBoundingClientRect();
        const clearance = Math.max(108, Math.ceil(stickyRect.height + MOBILE_WIDGET_GAP));

        Array.from(document.body.children).forEach((node) => {
          if (node === bar || node.matches?.('script, style, link, meta')) return;

          const computed = window.getComputedStyle(node);
          if (computed.position !== 'fixed' && computed.position !== 'sticky') return;

          const rect = node.getBoundingClientRect();
          if (!rect.width || !rect.height || !rectsOverlap(stickyRect, rect)) return;

          moveFloatingWidgetClear(node, clearance);
        });

        document.querySelectorAll(
          'iframe, [class*="currency" i], [id*="currency" i], [class*="converter" i], [id*="converter" i], [class*="chat" i], [id*="chat" i], [class*="vapi" i], [id*="vapi" i], [class*="chizy" i], [id*="chizy" i], [class*="gtranslate" i], [id*="gtranslate" i], [class*="translate" i], [id*="translate" i]'
        ).forEach((candidate) => {
          const fixed = findFixedAncestor(candidate);
          if (!fixed || fixed === bar || bar.contains(fixed)) return;

          const rect = fixed.getBoundingClientRect();
          if (rect.width && rect.height && rectsOverlap(stickyRect, rect)) {
            moveFloatingWidgetClear(fixed, clearance);
          }
        });

        if (bar.parentElement === document.body && bar !== document.body.lastElementChild) {
          document.body.appendChild(bar);
        }
      });
    });
  };

  const liftFixedChatAncestor = (node) => {
    const current = findFixedAncestor(node);
    if (!current) return;
    current.style.setProperty('right', '12px', 'important');
    current.style.setProperty('left', 'auto', 'important');
    current.style.setProperty('bottom', MOBILE_CHAT_CLEARANCE, 'important');
    current.style.setProperty('z-index', MOBILE_WIDGET_Z_INDEX, 'important');
  };

  const initMobileChatClearance = () => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    if (!document.querySelector('.pm-cro__mobile-buy, .pm-bmx__mobile-buy')) return;

    document.querySelectorAll('.vapi-widget-button, .vapi-widget-container, .vapi-widget-frame').forEach((node) => {
      node.style.setProperty('right', '12px', 'important');
      node.style.setProperty('left', 'auto', 'important');
      node.style.setProperty('bottom', MOBILE_CHAT_CLEARANCE, 'important');
      node.style.setProperty('z-index', MOBILE_WIDGET_Z_INDEX, 'important');
    });

    document.querySelectorAll('iframe, [class*="chizy" i], [id*="chizy" i]').forEach((node) => {
      const src = (node.getAttribute?.('src') || '').toLowerCase();
      const marker = `${node.id || ''} ${node.className || ''}`.toLowerCase();
      if (src.includes('chizy') || marker.includes('chizy')) {
        liftFixedChatAncestor(node);
      }
    });
  };

  const initStickyBuy = () => {
    const bar = document.querySelector('[data-pm-sticky-buy]');
    if (!bar) return;
    const triggerId = bar.querySelector('[data-pm-sticky-trigger]')?.dataset.pmStickyTrigger;
    const primary = triggerId ? document.getElementById(triggerId) : null;
    const stickyButton = bar.querySelector('[data-pm-sticky-trigger]');
    if (!primary || !stickyButton) return;

    const sync = () => {
      stickyButton.disabled = primary.disabled;
      stickyButton.textContent = primary.disabled ? 'SOLD OUT' : 'GET ACCESS';
    };
    sync();

    stickyButton.addEventListener('click', () => {
      sync();
      if (primary.disabled) {
        primary.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      primary.click();
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        if (window.matchMedia('(max-width: 749px)').matches) {
          bar.hidden = entry.isIntersecting;
        } else {
          bar.hidden = true;
        }
      }, { threshold: 0.1 });
      observer.observe(primary);
    } else if (window.matchMedia('(max-width: 749px)').matches) {
      bar.hidden = false;
    }

    document.addEventListener('change', () => setTimeout(sync, 80));
  };

  const refreshMobileLayers = () => {
    initCurrencyNotice();
    initMobileChatClearance();
    protectMobileSticky();
  };

  const init = () => {
    refreshMobileLayers();
    initStickyBuy();

    if (document.body && 'MutationObserver' in window) {
      let queued = false;
      const observer = new MutationObserver(() => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          refreshMobileLayers();
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    [300, 900, 1800, 3500, 7000, 11000].forEach((delay) => {
      window.setTimeout(refreshMobileLayers, delay);
    });

    window.addEventListener('resize', refreshMobileLayers, { passive: true });
    window.addEventListener('orientationchange', () => setTimeout(refreshMobileLayers, 120), { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', refreshMobileLayers);
})();
